import _ from 'lodash';

export const deepCopy = (value: any) => _.cloneDeep(value);
